import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Produto } from 'src/app/core/models/produto.model';
import { WeblabService } from 'src/app/core/services/weblab.service';
import { TableSelectColumn } from 'src/app/shared/components/table-select/table-select.component';

@Component({
  selector: 'app-novo-pedido-outros-servicos',
  templateUrl: './novo-pedido-outros-servicos.component.html',
  styleUrls: ['./novo-pedido-outros-servicos.component.scss']
})
export class NovoPedidoOutrosServicosComponent {
  @Input() servicosAdicionados: Produto[] = [];
  @Input() legend: string;
  @Input() laboratorioSelecionado: any;

  codigoServico: any;
  servicoSelecionado: Produto | null = null;
  olhoServico: any;
  quantidadeAdd: number = 1;

  comboOutrosServicosFiltrado: Produto[] = [];
  loadingServicos: boolean = false;
  debounceBuscarServicoCodigo: any = null;

  private brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  colunasServicos: TableSelectColumn[] = [
    { field: 'descricao',               header: 'Descrição do produto' },
    { field: 'vlr_liquido_produto',     header: 'Preço',  width: '110px', format: (v) => this.brl.format(v ?? 0) },
  ];

  constructor(
    private service: WeblabService,
    private toastr: ToastrService
  ) { }

  get olhoDesabilitado(): boolean {
    const ramoPermiteOlho = this.laboratorioSelecionado && (this.laboratorioSelecionado.ramo == 1 || this.laboratorioSelecionado.ramo == 2);
    const servicoEhLente = this.servicoSelecionado?.especie?.toString().trim().toUpperCase() === 'L';
    return !ramoPermiteOlho || !servicoEhLente;
  }

  onServicoSelecionadoChange() {
    if (this.olhoDesabilitado) {
      this.olhoServico = null;
    }
  }

  filterAutoComplete(event: { query: string }) {
    const self = this;
    let query = event.query;
    self.loadingServicos = true;
    this.service.produtos(query, this.laboratorioSelecionado?.id).subscribe({
      next(resp) {
        const produtos = (resp.dados || []).map((p) => {
          let vlr_venda_tratado = p.preco_venda;
          let perc_desconto = p.desc_acresc_porcentagem === null ? 0 : p.desc_acresc_porcentagem;

          return {
            ...p,
            desc_acresc_porcentagem: perc_desconto,
            vlr_venda_tratado: vlr_venda_tratado,
            vlr_liquido_produto: vlr_venda_tratado > 0 && perc_desconto > 0 ? vlr_venda_tratado - (vlr_venda_tratado * perc_desconto / 100) : vlr_venda_tratado
          }
        });

        self.comboOutrosServicosFiltrado = produtos;
        self.loadingServicos = false;
      },
      error(error) {
        self.comboOutrosServicosFiltrado = [];
        self.loadingServicos = false;
        const status = error.status;
        const message = error.error?.erro?.mensagem || error.message;
        if (status != 404) {
          self.toastr.error(message, 'Erro');
        }
      },
    });
  }

  buscarServicoCodigo() {
    const self = this;
    clearTimeout(self.debounceBuscarServicoCodigo);
    this.debounceBuscarServicoCodigo = setTimeout(() => {
      if (self.codigoServico) {
        this.service.produtosId(self.codigoServico, this.laboratorioSelecionado?.id).subscribe({
          next(resp) {
            const produtos = (resp.dados || []).map((p) => {
              let vlr_venda_tratado = p.preco_venda;
              let perc_desconto = p.desc_acresc_porcentagem === null ? 0 : p.desc_acresc_porcentagem;
              
              return {
                ...p,
                desc_acresc_porcentagem: perc_desconto,
                vlr_venda_tratado: vlr_venda_tratado,
                vlr_liquido_produto: vlr_venda_tratado > 0 && perc_desconto > 0 ? vlr_venda_tratado - (vlr_venda_tratado * perc_desconto / 100) : vlr_venda_tratado
              }
            });

            self.comboOutrosServicosFiltrado = produtos;
            self.servicoSelecionado = self.comboOutrosServicosFiltrado[0] || null;
            self.onServicoSelecionadoChange();

            if (self.comboOutrosServicosFiltrado.length == 0) {
              self.toastr.warning('Nenhum produto encontrado.', 'Aviso');
            }
          },
          error(error) {
            self.comboOutrosServicosFiltrado = [];
            self.servicoSelecionado = null;
            self.onServicoSelecionadoChange();
            const message = error.error?.erro?.mensagem || 'Nenhum produto encontrado.';

            self.toastr.error(message, 'Aviso');
          },
        });
      }
    }, 1000);
  }

  adicionarServico() {
    if (this.servicoSelecionado) {
      this.servicoSelecionado.quantidadeAdd = this.quantidadeAdd;
      this.servicoSelecionado.tipo_prod = this.olhoDesabilitado ? '' : this.olhoServico?.value;

      this.servicosAdicionados.push(this.servicoSelecionado);
    }

    this.olhoServico = null;
    this.servicoSelecionado = null;
    this.quantidadeAdd = 1;
    this.codigoServico = null;
  }

  deletarServico(servico: any, index: any) {
    this.servicosAdicionados.splice(index, 1);
  }
}